import { render } from "./ArtistCreateForm.vue?vue&type=template&id=2414a6a4&scoped=true"
import script from "./ArtistCreateForm.vue?vue&type=script&lang=js"
export * from "./ArtistCreateForm.vue?vue&type=script&lang=js"

import "./ArtistCreateForm.vue?vue&type=style&index=0&id=2414a6a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2414a6a4"]])

export default __exports__